import { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./PersonnelUsersUIHelpers";

const PersonnelUsersUIContext = createContext();

export function usePersonnelUsersUIContext() {
  return useContext(PersonnelUsersUIContext);
}

export const PersonnelUsersUIConsumer = PersonnelUsersUIContext.Consumer;

export function PersonnelUsersUIProvider({ personnelUsersUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openIPListEditModal: personnelUsersUIEvents.openIPListEditModal
  };

  return (
    <PersonnelUsersUIContext.Provider value={value}>
      {children}
    </PersonnelUsersUIContext.Provider>
  );
}